import { TourRoomType } from "@website/accommodation-ui/tour-booking/tour-draft-passengers-info/types";
import { RoomAttributeType } from "@website/accommodation-ui/tour-card/tour-card-hotel/types";
import { numberConvert } from "@website/utils/number-convert";

export const displayPassengersQuantity = (rooms: Array<RoomAttributeType>) =>
  rooms.reduce(
    (previousCount, room) =>
      previousCount + room.adultCount + (room.children?.length || 0),
    0
  );

export const countPassengersAdultAndChild = (
  rooms?: Array<RoomAttributeType> | Array<TourRoomType>
) => {
  const passengers = rooms?.reduce(
    (previousCount, room) => ({
      adult: previousCount.adult + room.adultCount,
      child: previousCount.child + (room.children?.length || 0)
    }),
    { adult: 0, child: 0 }
  );
  return passengers;
};

export const displayPassengersAdultAndChild = (
  rooms?: Array<RoomAttributeType>
) => {
  if (rooms) {
    const adult = countPassengersAdultAndChild(rooms)?.adult;
    const child = countPassengersAdultAndChild(rooms)?.child;
    return `${numberConvert(adult, { locale: "fa" })} بزرگسال${
      child ? ` و ${numberConvert(child, { locale: "fa" })} کودک` : ""
    }`;
  }
  return "۱ بزرگسال";
};
